import { Button, Grid, MenuItem, Select } from "@material-ui/core";
import { memo, useState } from "react";
import { useHistory } from "react-router-dom";
import Authorize from "../../../../components/Authorize";
import { permissionProfiles } from "../../../../components/Authorize/permissionProfiles";
import ExportButton from "../../../../components/ExportButton/ExportButton";
import { IconAdd, IconDownload, IconProfile } from "../../../../icons";
import CreateUserDialog from "../UserDialogs/CreateUserDialog";
import usersPageStyle from "./styles";

const useStyles = usersPageStyle;

const HeaderUserManagement = ({ users, roles, clients, lots, refetchUsers, mapExportData, inactiveValue, setInactiveValue }) => {
    const classes = useStyles();

    const [openDialog, setOpenDialog] = useState(false);
    const [clickedUser, setClickedUser] = useState(null);
    const history = useHistory();

    const onClickCreate = () => {
        setOpenDialog(true);
        setClickedUser(null);
    }

    return (
        <Grid container justifyContent="space-between">
            <Grid item>
                <span className={classes.headerTitle}>
                    <IconProfile />
                    Users Management
                </span>
            </Grid>
            <Grid item>
                <Grid container spacing={1}>
                    <Authorize profile={permissionProfiles.USER_MANAGEMENT.TOTAL_INACTIVE_VIEW_ACCESS_TABLE}>
                        <Grid item>
                            <Select
                                labelId="select-label"
                                value={inactiveValue}
                                onChange={(event) => setInactiveValue(event.target.value)}>
                                <MenuItem value={1}>1 Month</MenuItem>
                                <MenuItem value={3}>3 Months</MenuItem>
                                <MenuItem value={6}>6 Months</MenuItem>
                                <MenuItem value={12}>12+ Months</MenuItem>
                            </Select>
                        </Grid>
                    </Authorize>
                    <Authorize profile={permissionProfiles.USER.CREATE_USER}>
                        <Grid item>
                            <Button variant="contained" color="primary" startIcon={<IconAdd />} onClick={onClickCreate}>
                                Create User
                            </Button>
                        </Grid>
                    </Authorize>
                    <Grid item>
                        <ExportButton
                            fileLabel="users"
                            btnStyle="outlined"
                            icon={<IconDownload />}
                            label="Export"
                            data={users}
                            mapExportData={mapExportData}
                        />
                    </Grid>
                </Grid>
            </Grid>

            {openDialog && <CreateUserDialog refetchUsers={refetchUsers} roles={roles} clients={clients} lots={lots} open={openDialog} setOpenDialog={setOpenDialog} user={clickedUser}></CreateUserDialog>}
        </Grid>
    );
};

export default memo(HeaderUserManagement);
